import tw from 'tailwind-styled-components'
import {TwCheckboxType} from './types'

export const TwWrap = tw.div<{$disabled: boolean}>`
  flex
  items-start
  gap-8
  cursor-pointer
  ${p => (p.$disabled ? 'pointer-events-none' : '')}
`

const getCheckboxClasses = (
  error?: boolean,
  disabled?: boolean,
  active?: boolean
) => {
  if (error) {
    if (active) {
      return `bg-action-default border-error hover:bg-interactive-l20 hover:border-error`
    }
    return `bg-grey-l100 border-error hover:border-2`
  }

  if (disabled) {
    return `bg-grey-l20 border-grey-l20 pointer-events-none`
  }

  if (active) {
    return `bg-action-default border-action-default hover:bg-action-hover hover:border-action-hover active:bg-action-pressed active:border-action-pressed`
  }

  return `bg-primary border-icon-disabled hover:border-icon-placeholder active:border-icon-secondary`
}

export const TwCheckbox = tw.div<TwCheckboxType>`
  relative
  rounded-4
  w-16
  h-16
  min-w-16
  min-h-16

  outline-0
  active:outline-0

  border-solid
  border-1

  ${p => getCheckboxClasses(p.$error, p.$disabled, p.$active)}
`

export const TwText = tw.div<TwCheckboxType>`
  truncate
  ${p => {
    if (p.$type === 'checkbox') {
      const color = p.$disabled ? 'text-disabled' : 'text-primary'
      return `plain-text-regular ${color}`
    }
    if (p.$type === 'list') {
      const color = p.$disabled ? 'text-disabled' : 'text-primary'
      return `plain-text-regular ${color}`
    }
    if (p.$type === 'header-list') {
      const color = p.$disabled ? 'text-disabled' : 'text-secondary'
      return `micro-regular ${color}`
    }

    return ''
  }}
`

export const TwActiveUndefined = tw.div`
  h-6
  w-6
  bg-grey-l100-white
  rounded-[1.33px]
`

export const TwActiveWrap = tw.div`
  flex
  justify-center
  items-center
  h-full
`

// export const TwSupport = tw.div<TwCheckboxType>`
//   micro-semibold
//   truncate
//   ${p => (p.$disabled ? 'text-grey-l20' : 'text-grey')}
// `
